var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('b-row',[_c('b-col',{staticClass:"col-nav",attrs:{"cols":"12"}},[_c('horizontal-nav',{attrs:{"set_sub_view":"","show_display":false,"items":_vm.items},on:{"setSelected":_vm.setSelected}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }